import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatNumber } from '../../../../utils/Helpers'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
// import { GET_CART_CHANGE_OPENED } from '../../../../queries/cart'

const GET_CART_CHANGE_OPENED = gql`
  query GetCartChangeOpened($filters: EventCartChangeFilter){
    eventCartChangeCount(
      filters: $filters,
      index: "eventos-fapp-cart-change-opened*"
    )
  } 
`

const CounterCartChangeOpened = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_CART_CHANGE_OPENED, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Qtd. de exibições da modal de troca de cesta" number={formatNumber(data.eventCartChangeCount)} color={Colors.blue} />
  )
}

export default CounterCartChangeOpened
